import { ActionTree } from 'vuex';
import Axios, { AxiosResponse } from 'axios';
import { ApplicationsState, ConversationMessage, MessageToSend } from './types';
import { readMeta } from '@/lib/page';
import { refreshedJwt } from '@/lib/jwt';

const actions: ActionTree<ApplicationsState, any> = {
  async postConversationData(_, { conversationUUID, messageBody }: ConversationMessage): Promise<void | AxiosResponse<any>> {
    const scPublicApiUrl = readMeta('sc_public_api_url');
    const token = await refreshedJwt();
    if (!token) throw new Error('Cannot message without being logged in');

    const messageToSend: MessageToSend = {
      'com.sittercity.messages:Message': {
        body: messageBody,
      },
    };

    return Axios.post(`${scPublicApiUrl}/conversations/${conversationUUID}/messages`, messageToSend, {
      headers: {
        Accept: 'application/json; version=2',
        'Content-Type': 'application/json',
        authorization: `Bearer ${token}`,
      },
    }).catch((err) => {
      // @ts-ignore

      console.error(err);
    });
  },

  moveAppFromReceivedToInterested({ commit, getters }) {
    commit('setRemoveApplicantFromList');
    const receivedMinusOne: number = getters.receivedTotal - 1;
    const interestedPlusOne: number = getters.interestedTotal + 1;
    commit('setReceivedTotal', { applications: { totalCount: receivedMinusOne } });
    commit('setInterestedTotal', { applications: { totalCount: interestedPlusOne } });
  },

  moveAppFromReceivedToNotAFit({ commit, getters }) {
    commit('setRemoveApplicantFromList');
    const receivedMinusOne: number = getters.receivedTotal - 1;
    const notAFitPlusOne: number = getters.notAFitTotal + 1;
    commit('setReceivedTotal', { applications: { totalCount: receivedMinusOne } });
    commit('setNotAFitTotal', { applications: { totalCount: notAFitPlusOne } });
  },

  moveAppFromInterestedToNotAFit({ commit, getters }) {
    commit('setRemoveApplicantFromList');
    const interestedMinusOne: number = getters.interestedTotal - 1;
    const notAFitPlusOne: number = getters.notAFitTotal + 1;
    commit('setInterestedTotal', { applications: { totalCount: interestedMinusOne } });
    commit('setNotAFitTotal', { applications: { totalCount: notAFitPlusOne } });
  },

  moveAppFromNotAFitToReceived({ commit, getters }) {
    commit('setRemoveApplicantFromList');
    const notAFitMinusOne: number = getters.notAFitTotal - 1;
    const receivedPlusOne: number = getters.receivedTotal + 1;
    commit('setNotAFitTotal', { applications: { totalCount: notAFitMinusOne } });
    commit('setReceivedTotal', { applications: { totalCount: receivedPlusOne } });
  },

  showMessageSentNotification({ commit }, message: string): void {
    commit('setMessageSentNotification', true);
    commit('setToastNotificationMessage', message);
  },

  hideMessageSentNotification({ commit }): void {
    commit('setMessageSentNotification', false);
  },

  showApplicationLoading({ commit }, changeTo: boolean): void {
    commit('setShowApplicationLoading', changeTo);
  },
};

export default actions;
